import React, { useState, useEffect, useContext } from 'react'
import { GlobalContext } from '../../context/Global'
import styles from './tourisminfo.module.scss'
import { Info } from './Info'
import axios from 'axios'
import { Loader } from '../Loader'

export const TourismInfo = () => {
  const { analysisType, filteredFrom, filteredTo } = useContext(GlobalContext)

  const isTrip = analysisType === 'trip'

  const [tourismDataFrom, setTourismDataFrom] = useState([])
  const [tourismDataTo, setTourismDataTo] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getTourismData = async () => {
      setLoading(true)
      const URL = '/api/restrictions'

      const config = {
        method: 'GET',
        mode: 'cors',
        url: URL
      }

      const res = await axios(config)
      const filteredTourismDataFrom = res.data.filter(
        (state) => state['Bundesland'] === filteredFrom[0]?.attributes.BL
      )
      const filteredTourismDataTo = res.data.filter(
        (state) => state['Bundesland'] === filteredTo[0]?.attributes.BL
      )
      setTourismDataFrom(filteredTourismDataFrom)
      setTourismDataTo(filteredTourismDataTo)

      setLoading(false)
    }

    getTourismData()
  }, [])

  return (
    <div className={styles.wrapper}>
      {loading ? (
        <div className={styles.loader}>
          <Loader variant="secondary" />
        </div>
      ) : (
        <>
          <Info data={tourismDataFrom} />
          {isTrip && <Info data={tourismDataTo} />}
        </>
      )}
    </div>
  )
}
